import { render, staticRenderFns } from "./RulesIcon.vue?vue&type=template&id=5ee465e6"
import script from "./RulesIcon.vue?vue&type=script&lang=js"
export * from "./RulesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports